const office_start = 8;
const office_end = 23;

export const date_n_time = {
  office_start,
  office_end,
};
